import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
  selector: 'app-interest-filter',
  templateUrl: './interest-filter.component.html',
  styleUrls: ['./interest-filter.component.scss']
})
export class InterestFilterComponent implements OnInit {

  isCollapsed = false;
  protected subs = new SubSink();
  hotelsCopy: any;
  uniquePOIs: any[] = [];
  selectedPOIs: string[] = []; // Array to store selected POIs

  constructor(private hotelService: HotelService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.subs.sink = this.hotelService.hotelsCopy.subscribe(res => {
      if (res.length) {
        this.hotelsCopy = res;
        this.uniquePOIs = this.getUniquePOIs(res);
      } else {
        this.hotelsCopy = [];
      }
      this.cdr.detectChanges();
    });
  
    // Sync POIs with the service state
    this.subs.sink = this.hotelService.selectedHotelPOIs.subscribe(pois => {
      this.selectedPOIs = [...pois]; // Update local selection
      this.cdr.detectChanges(); // Ensure the UI reflects the state
    });
  }   

  // Function to filter unique POIs
  getUniquePOIs(hotels) {
    const pois = hotels.reduce((acc, hotel) => {
      return acc.concat(hotel.PoinOfInterest || []);
    }, []);
  
    return pois.filter((poi, index, self) =>
      index === self.findIndex((p) => p.poiName.trim().toLowerCase() === poi.poiName.trim().toLowerCase())
    );
  }  

  // Handle checkbox selection
  onPOIChange(poiName: string, isChecked: boolean) {
    let currentPOIs = this.hotelService.selectedHotelPOIs.getValue();
  
    if (isChecked) {
      if (!currentPOIs.includes(poiName)) {
        currentPOIs.push(poiName);
      }
    } else {
      currentPOIs = currentPOIs.filter(poi => poi !== poiName);
    }
  
    this.hotelService.selectedHotelPOIs.next(currentPOIs);
    this.applyFilters();
  }

  applyFilters() {
    this.hotelService.setByPOI();
  }

  resetFilter() {
    this.selectedPOIs = []; // Clear local POIs selection
    this.hotelService.resetPOIFilter(); // Trigger reset in the service
  }  
}
